import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Feature, Map, View } from 'ol';
import Point from 'ol/geom/Point';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import { fromLonLat, toLonLat } from 'ol/proj';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import { Icon, Style } from 'ol/style';

@Component({
  selector: 'app-position-dialog',
  templateUrl: './position-dialog.component.html',
  styleUrls: ['./position-dialog.component.scss'],
})
export class PositionDialogComponent implements OnInit {
  address: string;
  position: number[];
  alternativePositionCity: number[];
  newPosition: number[] = [];
  addressPositionForm: FormGroup;
  map: Map;
  feature: Feature;
  marker: Point;

  @ViewChild('mapDiv') mapDiv: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PositionDialogComponent>
  ) {
    this.address = data.address;
    this.position = data.position;
    this.alternativePositionCity = data.alternativePositionCity;
    this.addressPositionForm = this.fb.group({
      longitude: [null],
      latitude: [null],
    });
  }

  ngOnInit(): void {
    if (this.position?.length) {
      this.addressPositionForm.patchValue({
        longitude: this.position[0],
        latitude: this.position[1],
      });
    }
    setTimeout(() => {
      if (this.position?.length) {
        this.marker = new Point(fromLonLat(this.position));
        this.feature = new Feature({
          geometry: this.marker,
        });
      }
      this.map = new Map({
        view: new View({
          center:
            this.position?.length || this.alternativePositionCity?.length
              ? fromLonLat(
                  this.position?.length
                    ? this.position
                    : this.alternativePositionCity
                )
              : [0, 0],
          zoom:
            this.position?.length || this.alternativePositionCity?.length
              ? 10
              : 0,
        }),
        target: this.mapDiv?.nativeElement,
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        controls: [],
      });
      if (this.position?.length) {
        this.map.addLayer(
          new VectorLayer({
            source: new VectorSource({
              features: [this.feature],
            }),
          })
        );
        this.feature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              src:
                `data:image/svg+xml;utf8,` +
                escape(
                  `<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 26.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg width="40" height="40" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><style type="text/css">.st0{fill:#006B61;}.st1{fill:#FFFFFF;}</style><path class="st0" d="M267.4,2.8c100.2,0,181.5,81.3,181.5,181.5S267.4,508.4,267.4,508.4S85.9,284.5,85.9,184.3C85.9,84,167.2,2.8,267.4,2.8z"/><path class="st1" d="M294.8,143v49.9c0,4.1-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5V143c0-4.1,3.4-7.5,7.5-7.5C291.5,135.5,294.8,138.8,294.8,143z M327.3,135.5c-4.1,0-7.5,3.4-7.5,7.5v49.9c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5V143C334.8,138.8,331.4,135.5,327.3,135.5z M207.5,185.4c-4.1,0-7.5,3.4-7.5,7.5v39.9c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-39.9C215,188.8,211.7,185.4,207.5,185.4z M374.7,252.3c2.3,18.3-10.6,35.2-28.9,37.8c-3,0.4-6,0.5-9.1,0.1h-9.5h-39.9h-9.5c-1.1,0.1-2.3,0.2-3.4,0.2c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0-0.3,0c-0.5,0-1-0.1-1.5-0.1c-0.9,0-1.8,0-2.7-0.2H198c-1.4,0.2-2.9,0.3-4.3,0.3c-7.3,0-14.4-2.4-20.3-6.8c-7.3-5.4-12-13.3-13.3-22.3c-0.4-3-0.5-6-0.1-9v-78.9c-1.1-8.8,1.2-17.5,6.5-24.6c5.4-7.2,13.4-12,22.4-13.2c0.3,0,0.7,0,1.1-0.1V123c0-15.1,12.3-27.4,27.4-27.4h25.2c1.1-2.3,2.2-4.6,3.8-6.7c5.4-7.3,13.3-12,22.4-13.3c3-0.4,6-0.5,9.1-0.1h58.9c18.4-2.3,35.2,10.6,37.8,28.9c0.4,3,0.5,6,0.1,9.1L374.7,252.3L374.7,252.3z M205,135.5H240v-21.9c-0.1-1,0-2-0.1-3h-22.4c-6.9,0-12.5,5.6-12.5,12.5L205,135.5L205,135.5zM245.3,275.2c-0.1-0.2-0.2-0.4-0.3-0.6c-0.6-0.9-1.1-1.9-1.6-2.9c-0.5-0.9-0.9-1.9-1.3-2.8c-0.3-0.9-0.6-1.8-0.9-2.8c-0.3-1.2-0.6-2.3-0.8-3.5c-0.1-0.5-0.3-0.9-0.3-1.4c-0.1-0.6-0.1-1.2-0.1-1.9c0-0.5-0.1-1.1-0.1-1.6c-0.1-1.9,0-3.7,0.2-5.5V150.5h-42.5c-0.3,0-0.7,0-1.1-0.1c-0.9-0.1-1.8-0.2-2.7-0.2c-0.9,0-1.8,0.1-2.7,0.2c-5,0.7-9.5,3.3-12.5,7.4c-3,4-4.3,9.1-3.6,14.1c0,0.3,0.1,0.7,0.1,1.1v79.9c0,0.4,0,0.7-0.1,1.1c-0.3,1.8-0.3,3.6,0,5.3c0.7,5,3.3,9.5,7.4,12.5c4,3,9.1,4.3,14.1,3.6c0.3,0,0.7-0.1,1.1-0.1L245.3,275.2L245.3,275.2z M319.8,275.2v-32.5c0-1.4-1.1-2.5-2.5-2.5h-20c-1.4,0-2.5,1.1-2.5,2.5v32.5H319.8zM359.8,253.8c0-0.3-0.1-0.7-0.1-1.1V113c0-0.4,0-0.7,0.1-1.1c0.3-1.8,0.3-3.6,0-5.3c-1.5-10.4-11.2-17.6-21.5-16.1c-0.3,0-0.7,0.1-1.1,0.1h-59.9c-0.3,0-0.7,0-1.1-0.1c-0.9-0.1-1.8-0.2-2.7-0.2c-0.9,0-1.8,0.1-2.7,0.2c-5,0.7-9.5,3.3-12.5,7.4c-1.2,1.6-2,3.3-2.6,5.1c0,0.6,0.1,1.3,0,1.9c-0.6,2.6-0.9,5.3-0.9,8v0.2v29.9v109.8c0,0.3,0,0.7-0.1,1.1c0,0,0,0.1,0,0.1c-0.2,1.6-0.2,3.1,0,4.7c0,0.5,0.1,1.1,0.3,1.6c0.1,0.6,0.3,1.2,0.4,1.8c0.2,0.6,0.4,1.3,0.7,1.9c0.2,0.5,0.4,1,0.7,1.4c0.3,0.6,0.7,1.2,1.1,1.8c0.3,0.4,0.6,0.8,0.9,1.2c0.4,0.5,0.9,1.1,1.3,1.5c0.4,0.4,0.8,0.8,1.3,1.1c0.5,0.4,1,0.8,1.5,1.1c0.5,0.3,1.1,0.7,1.6,1c0.5,0.3,1.1,0.6,1.6,0.8c0.5,0.3,1.1,0.4,1.7,0.6c0.6,0.2,1.2,0.4,1.9,0.5c0.4,0.1,0.9,0.1,1.3,0.2h6.3h2.5v-32.5c0-9.6,7.8-17.5,17.5-17.5h20c9.6,0,17.5,7.8,17.5,17.5v32.5h2.5c0.3,0,0.7,0,1.1,0.1c1.8,0.3,3.6,0.3,5.4,0c5-0.7,9.5-3.3,12.5-7.4C359.2,263.8,360.5,258.8,359.8,253.8z"/></svg>`
                ),
            }),
          })
        );
      }
      this.map.on('singleclick', (evt) => {
        if (!this.position?.length && !this.newPosition?.length) {
          this.marker = new Point(fromLonLat(evt.coordinate));
          this.feature = new Feature({
            geometry: this.marker,
          });
          this.map.addLayer(
            new VectorLayer({
              source: new VectorSource({
                features: [this.feature],
              }),
            })
          );
          this.feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                src:
                  `data:image/svg+xml;utf8,` +
                  escape(
                    `<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 26.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg width="40" height="40" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><style type="text/css">.st0{fill:#006B61;}.st1{fill:#FFFFFF;}</style><path class="st0" d="M267.4,2.8c100.2,0,181.5,81.3,181.5,181.5S267.4,508.4,267.4,508.4S85.9,284.5,85.9,184.3C85.9,84,167.2,2.8,267.4,2.8z"/><path class="st1" d="M294.8,143v49.9c0,4.1-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5V143c0-4.1,3.4-7.5,7.5-7.5C291.5,135.5,294.8,138.8,294.8,143z M327.3,135.5c-4.1,0-7.5,3.4-7.5,7.5v49.9c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5V143C334.8,138.8,331.4,135.5,327.3,135.5z M207.5,185.4c-4.1,0-7.5,3.4-7.5,7.5v39.9c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-39.9C215,188.8,211.7,185.4,207.5,185.4z M374.7,252.3c2.3,18.3-10.6,35.2-28.9,37.8c-3,0.4-6,0.5-9.1,0.1h-9.5h-39.9h-9.5c-1.1,0.1-2.3,0.2-3.4,0.2c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0-0.3,0c-0.5,0-1-0.1-1.5-0.1c-0.9,0-1.8,0-2.7-0.2H198c-1.4,0.2-2.9,0.3-4.3,0.3c-7.3,0-14.4-2.4-20.3-6.8c-7.3-5.4-12-13.3-13.3-22.3c-0.4-3-0.5-6-0.1-9v-78.9c-1.1-8.8,1.2-17.5,6.5-24.6c5.4-7.2,13.4-12,22.4-13.2c0.3,0,0.7,0,1.1-0.1V123c0-15.1,12.3-27.4,27.4-27.4h25.2c1.1-2.3,2.2-4.6,3.8-6.7c5.4-7.3,13.3-12,22.4-13.3c3-0.4,6-0.5,9.1-0.1h58.9c18.4-2.3,35.2,10.6,37.8,28.9c0.4,3,0.5,6,0.1,9.1L374.7,252.3L374.7,252.3z M205,135.5H240v-21.9c-0.1-1,0-2-0.1-3h-22.4c-6.9,0-12.5,5.6-12.5,12.5L205,135.5L205,135.5zM245.3,275.2c-0.1-0.2-0.2-0.4-0.3-0.6c-0.6-0.9-1.1-1.9-1.6-2.9c-0.5-0.9-0.9-1.9-1.3-2.8c-0.3-0.9-0.6-1.8-0.9-2.8c-0.3-1.2-0.6-2.3-0.8-3.5c-0.1-0.5-0.3-0.9-0.3-1.4c-0.1-0.6-0.1-1.2-0.1-1.9c0-0.5-0.1-1.1-0.1-1.6c-0.1-1.9,0-3.7,0.2-5.5V150.5h-42.5c-0.3,0-0.7,0-1.1-0.1c-0.9-0.1-1.8-0.2-2.7-0.2c-0.9,0-1.8,0.1-2.7,0.2c-5,0.7-9.5,3.3-12.5,7.4c-3,4-4.3,9.1-3.6,14.1c0,0.3,0.1,0.7,0.1,1.1v79.9c0,0.4,0,0.7-0.1,1.1c-0.3,1.8-0.3,3.6,0,5.3c0.7,5,3.3,9.5,7.4,12.5c4,3,9.1,4.3,14.1,3.6c0.3,0,0.7-0.1,1.1-0.1L245.3,275.2L245.3,275.2z M319.8,275.2v-32.5c0-1.4-1.1-2.5-2.5-2.5h-20c-1.4,0-2.5,1.1-2.5,2.5v32.5H319.8zM359.8,253.8c0-0.3-0.1-0.7-0.1-1.1V113c0-0.4,0-0.7,0.1-1.1c0.3-1.8,0.3-3.6,0-5.3c-1.5-10.4-11.2-17.6-21.5-16.1c-0.3,0-0.7,0.1-1.1,0.1h-59.9c-0.3,0-0.7,0-1.1-0.1c-0.9-0.1-1.8-0.2-2.7-0.2c-0.9,0-1.8,0.1-2.7,0.2c-5,0.7-9.5,3.3-12.5,7.4c-1.2,1.6-2,3.3-2.6,5.1c0,0.6,0.1,1.3,0,1.9c-0.6,2.6-0.9,5.3-0.9,8v0.2v29.9v109.8c0,0.3,0,0.7-0.1,1.1c0,0,0,0.1,0,0.1c-0.2,1.6-0.2,3.1,0,4.7c0,0.5,0.1,1.1,0.3,1.6c0.1,0.6,0.3,1.2,0.4,1.8c0.2,0.6,0.4,1.3,0.7,1.9c0.2,0.5,0.4,1,0.7,1.4c0.3,0.6,0.7,1.2,1.1,1.8c0.3,0.4,0.6,0.8,0.9,1.2c0.4,0.5,0.9,1.1,1.3,1.5c0.4,0.4,0.8,0.8,1.3,1.1c0.5,0.4,1,0.8,1.5,1.1c0.5,0.3,1.1,0.7,1.6,1c0.5,0.3,1.1,0.6,1.6,0.8c0.5,0.3,1.1,0.4,1.7,0.6c0.6,0.2,1.2,0.4,1.9,0.5c0.4,0.1,0.9,0.1,1.3,0.2h6.3h2.5v-32.5c0-9.6,7.8-17.5,17.5-17.5h20c9.6,0,17.5,7.8,17.5,17.5v32.5h2.5c0.3,0,0.7,0,1.1,0.1c1.8,0.3,3.6,0.3,5.4,0c5-0.7,9.5-3.3,12.5-7.4C359.2,263.8,360.5,258.8,359.8,253.8z"/></svg>`
                  ),
              }),
            })
          );
        }
        this.marker.setCoordinates(evt.coordinate);
        this.addressPositionForm
          .get('longitude')
          .setValue(toLonLat(evt.coordinate)[0]);
        this.addressPositionForm
          .get('latitude')
          .setValue(toLonLat(evt.coordinate)[1]);
        this.newPosition = toLonLat(evt.coordinate);
      });
    }, 10);
  }

  checkAndSetCoordinates(): void {
    if (
      this.addressPositionForm.get('longitude').value &&
      this.addressPositionForm.get('latitude').value
    ) {
      if (!this.marker) {
        this.marker = new Point(
          fromLonLat([
            this.addressPositionForm.get('longitude').value,
            this.addressPositionForm.get('latitude').value,
          ])
        );
        this.feature = new Feature({
          geometry: this.marker,
        });
        this.map.addLayer(
          new VectorLayer({
            source: new VectorSource({
              features: [this.feature],
            }),
          })
        );
        this.feature.setStyle(
          new Style({
            image: new Icon({
              anchor: [0.5, 1],
              src:
                `data:image/svg+xml;utf8,` +
                escape(
                  `<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 26.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg width="40" height="40" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><style type="text/css">.st0{fill:#006B61;}.st1{fill:#FFFFFF;}</style><path class="st0" d="M267.4,2.8c100.2,0,181.5,81.3,181.5,181.5S267.4,508.4,267.4,508.4S85.9,284.5,85.9,184.3C85.9,84,167.2,2.8,267.4,2.8z"/><path class="st1" d="M294.8,143v49.9c0,4.1-3.4,7.5-7.5,7.5c-4.1,0-7.5-3.4-7.5-7.5V143c0-4.1,3.4-7.5,7.5-7.5C291.5,135.5,294.8,138.8,294.8,143z M327.3,135.5c-4.1,0-7.5,3.4-7.5,7.5v49.9c0,4.1,3.4,7.5,7.5,7.5c4.1,0,7.5-3.4,7.5-7.5V143C334.8,138.8,331.4,135.5,327.3,135.5z M207.5,185.4c-4.1,0-7.5,3.4-7.5,7.5v39.9c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-39.9C215,188.8,211.7,185.4,207.5,185.4z M374.7,252.3c2.3,18.3-10.6,35.2-28.9,37.8c-3,0.4-6,0.5-9.1,0.1h-9.5h-39.9h-9.5c-1.1,0.1-2.3,0.2-3.4,0.2c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0-0.3,0c-0.5,0-1-0.1-1.5-0.1c-0.9,0-1.8,0-2.7-0.2H198c-1.4,0.2-2.9,0.3-4.3,0.3c-7.3,0-14.4-2.4-20.3-6.8c-7.3-5.4-12-13.3-13.3-22.3c-0.4-3-0.5-6-0.1-9v-78.9c-1.1-8.8,1.2-17.5,6.5-24.6c5.4-7.2,13.4-12,22.4-13.2c0.3,0,0.7,0,1.1-0.1V123c0-15.1,12.3-27.4,27.4-27.4h25.2c1.1-2.3,2.2-4.6,3.8-6.7c5.4-7.3,13.3-12,22.4-13.3c3-0.4,6-0.5,9.1-0.1h58.9c18.4-2.3,35.2,10.6,37.8,28.9c0.4,3,0.5,6,0.1,9.1L374.7,252.3L374.7,252.3z M205,135.5H240v-21.9c-0.1-1,0-2-0.1-3h-22.4c-6.9,0-12.5,5.6-12.5,12.5L205,135.5L205,135.5zM245.3,275.2c-0.1-0.2-0.2-0.4-0.3-0.6c-0.6-0.9-1.1-1.9-1.6-2.9c-0.5-0.9-0.9-1.9-1.3-2.8c-0.3-0.9-0.6-1.8-0.9-2.8c-0.3-1.2-0.6-2.3-0.8-3.5c-0.1-0.5-0.3-0.9-0.3-1.4c-0.1-0.6-0.1-1.2-0.1-1.9c0-0.5-0.1-1.1-0.1-1.6c-0.1-1.9,0-3.7,0.2-5.5V150.5h-42.5c-0.3,0-0.7,0-1.1-0.1c-0.9-0.1-1.8-0.2-2.7-0.2c-0.9,0-1.8,0.1-2.7,0.2c-5,0.7-9.5,3.3-12.5,7.4c-3,4-4.3,9.1-3.6,14.1c0,0.3,0.1,0.7,0.1,1.1v79.9c0,0.4,0,0.7-0.1,1.1c-0.3,1.8-0.3,3.6,0,5.3c0.7,5,3.3,9.5,7.4,12.5c4,3,9.1,4.3,14.1,3.6c0.3,0,0.7-0.1,1.1-0.1L245.3,275.2L245.3,275.2z M319.8,275.2v-32.5c0-1.4-1.1-2.5-2.5-2.5h-20c-1.4,0-2.5,1.1-2.5,2.5v32.5H319.8zM359.8,253.8c0-0.3-0.1-0.7-0.1-1.1V113c0-0.4,0-0.7,0.1-1.1c0.3-1.8,0.3-3.6,0-5.3c-1.5-10.4-11.2-17.6-21.5-16.1c-0.3,0-0.7,0.1-1.1,0.1h-59.9c-0.3,0-0.7,0-1.1-0.1c-0.9-0.1-1.8-0.2-2.7-0.2c-0.9,0-1.8,0.1-2.7,0.2c-5,0.7-9.5,3.3-12.5,7.4c-1.2,1.6-2,3.3-2.6,5.1c0,0.6,0.1,1.3,0,1.9c-0.6,2.6-0.9,5.3-0.9,8v0.2v29.9v109.8c0,0.3,0,0.7-0.1,1.1c0,0,0,0.1,0,0.1c-0.2,1.6-0.2,3.1,0,4.7c0,0.5,0.1,1.1,0.3,1.6c0.1,0.6,0.3,1.2,0.4,1.8c0.2,0.6,0.4,1.3,0.7,1.9c0.2,0.5,0.4,1,0.7,1.4c0.3,0.6,0.7,1.2,1.1,1.8c0.3,0.4,0.6,0.8,0.9,1.2c0.4,0.5,0.9,1.1,1.3,1.5c0.4,0.4,0.8,0.8,1.3,1.1c0.5,0.4,1,0.8,1.5,1.1c0.5,0.3,1.1,0.7,1.6,1c0.5,0.3,1.1,0.6,1.6,0.8c0.5,0.3,1.1,0.4,1.7,0.6c0.6,0.2,1.2,0.4,1.9,0.5c0.4,0.1,0.9,0.1,1.3,0.2h6.3h2.5v-32.5c0-9.6,7.8-17.5,17.5-17.5h20c9.6,0,17.5,7.8,17.5,17.5v32.5h2.5c0.3,0,0.7,0,1.1,0.1c1.8,0.3,3.6,0.3,5.4,0c5-0.7,9.5-3.3,12.5-7.4C359.2,263.8,360.5,258.8,359.8,253.8z"/></svg>`
                ),
            }),
          })
        );
      }
      this.marker.setCoordinates(
        fromLonLat([
          this.addressPositionForm.get('longitude').value,
          this.addressPositionForm.get('latitude').value,
        ])
      );
      this.map
        .getView()
        .setCenter(
          fromLonLat([
            this.addressPositionForm.get('longitude').value,
            this.addressPositionForm.get('latitude').value,
          ])
        );
      this.map.getView().setZoom(10);
      this.newPosition = [
        this.addressPositionForm.get('longitude').value,
        this.addressPositionForm.get('latitude').value,
      ];
    }
  }

  savePosition(): void {
    this.newPosition = [
      this.addressPositionForm.get('longitude').value,
      this.addressPositionForm.get('latitude').value,
    ];
    this.dialogRef.close(this.newPosition);
  }
}
